import { render, staticRenderFns } from "./RecallApproval.vue?vue&type=template&id=e5e75ace&"
import script from "./RecallApproval.vue?vue&type=script&lang=js&"
export * from "./RecallApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports